// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"e787cc3f","76":"e841b5cc","223":"61bbb51a","232":"97faac2c","329":"50a5b323","366":"ac50bc39","480":"5abc9bd9","681":"0d5d7401","787":"21136fc7","938":"cc64b5cf","975":"6adb1731"}[chunkId] + ".chunk.js";
};